<div class="exercise-entry-block" (click)="openExercise()" [ngClass]="colorClasses">
  {{description}}
</div>